module.exports = __webpack_public_path__ + "img/logo.48d969e8.png";